function isNonStop(ticket) {
  if (!ticket || !ticket.FlightSegments || !ticket.FlightSegments.length) return false;

  const segs = ticket.FlightSegments;
  const counts = {};
  let hasDirection = false;

  for (const seg of segs) {
    if (!seg) continue;
    const dir = String(seg.DirectionInd);
    if (dir === '0' || dir === '1') {
      hasDirection = true;
      counts[dir] = (counts[dir] || 0) + 1;
    }
  }

  if (hasDirection) {
    if (Object.values(counts).some(c => c > 1)) return false;
    if (segs.length === 2 && counts['0'] === 1 && counts['1'] === 1) return true;
    return segs.length === 1;
  }
  return segs.length === 1;
}

function getFareType(ticket) {
  if (!ticket || !ticket.PricingInfo) return null;
  if (ticket.PricingInfo.FareInfoType) return ticket.PricingInfo.FareInfoType;
  const fb = ticket.PricingInfo.FareBreakdowns;
  return (fb && fb[0] && fb[0].FareInfoType) || null;
}

function timeToMinutes(timeStr) {
  if (!timeStr) return null;
  const parts = timeStr.split(':');
  return parseInt(parts[0], 10) * 60 + parseInt(parts[1] || '0', 10);
}

function applyTimeRangeFilter(tickets, segField, range) {
  if (!range || range.length !== 2 || range[0] == null || range[1] == null) return tickets;
  const startMin = range[0] * 60;
  const endMin = range[1] * 60;
  return tickets.filter(t =>
    (t.FlightSegments || []).some(seg => {
      const m = timeToMinutes(seg && seg[segField]);
      return m != null && m >= startMin && m <= endMin;
    })
  );
}

import { resolveFlightTotalFare } from "../comp/ucak/comp/fareCurrency";

export function applyFlightFilters(tickets, filter, currency = 'TRY') {
  let result = tickets.slice();

  if (filter.ticketPrice > 0) {
    result = result.filter(t => resolveFlightTotalFare(t, currency) <= filter.ticketPrice);
  }

  result = applyTimeRangeFilter(result, 'DepartureTime', filter.timeDepartureRange);
  result = applyTimeRangeFilter(result, 'ArrivalTime', filter.timeDestinationRange);

  if (filter.direct && !filter.transfer) {
    result = result.filter(t => isNonStop(t));
  } else if (!filter.direct && filter.transfer) {
    result = result.filter(t => !isNonStop(t));
  }

  if (filter.airline && filter.airline.length > 0) {
    const selected = filter.airline.filter(a => a.value).map(a => a.code);
    if (selected.length > 0) {
      result = result.filter(t =>
        (t.FlightSegments || []).some(seg => selected.includes(seg && seg.MarkettingAirline))
      );
    }
  }

  if (filter.flex && !filter.promo) {
    result = result.filter(t => getFareType(t) === 'Flex');
  } else if (!filter.flex && filter.promo) {
    result = result.filter(t => getFareType(t) === 'Promo');
  }

  return result;
}
